import React from 'react';
import styles from './styles.module.scss';
import {ReactComponent as MoneyBagIcon} from 'svg/money-bag.svg';
import {ReactComponent as DoneIcon} from 'svg/done-icon.svg';
import {ReactComponent as BusinessTimeIcon} from 'svg/business-time.svg';
import Title from 'components/typografy/title';
import Text from 'components/typografy/text';
import {useQuery} from 'react-query';
import {activityStats} from 'api/user';
import {QUERY_KEYS} from '../../../constants'; // Query keys used to cache and identify API data
import { ActivityStatsResponse } from 'types/user'; 

const Info: React.FC = () => {

  // Use React Query to fetch user activity stats (managed by the header component)
  const { data: stats } = useQuery<ActivityStatsResponse>(
    [QUERY_KEYS.USER.ACTIVITY_STATS],
    activityStats,
    {
      enabled: false, // Only reads from cache, disable automatic refetching, rely on header component to manage refetching
    }
  );


  return (
    <div className={styles.wrapper}>
      <div className={styles.item}>
        <div className={styles.icon}>
          <MoneyBagIcon />
        </div>
        <div>
          <div className={styles.textRow}>
            <Title variant={'h2'}>
              $
            </Title>
            <Title variant={'h2'}>{Number(stats?.earnings_sum ?? 0).toFixed(2)}</Title>
          </div>
          <div className={styles.textRow}>
            <Text variant={'medium'} nativeClassname={styles.text}>Lifetime Earnings</Text>
          </div>
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.icon}>
          <DoneIcon />
        </div>
        <div>
          <div className={styles.textRow}>
            <Title variant={'h2'}>{stats?.completed_rewards_count || 0}</Title>
          </div>
          <div className={styles.textRow}>
            <Text variant={'medium'} nativeClassname={styles.text}>Completed Rewards</Text>
          </div>
        </div>
      </div>
      <div className={styles.item}>
        <div className={styles.icon}>
          <BusinessTimeIcon />
        </div>
        <div>
          <div className={styles.textRow}>
            <Title variant={'h2'}>
              $
            </Title>
            <Title variant={'h2'}>{Number(stats?.withdrawals_sum ?? 0).toFixed(2)}</Title>
          </div>
          <div className={styles.textRow}>
            <Text variant={'medium'} nativeClassname={styles.text}>Lifetime Withdrawals</Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Info;
